import { render, staticRenderFns } from "./TaskManagement.vue?vue&type=template&id=01322476&"
import script from "./TaskManagement.vue?vue&type=script&lang=js&"
export * from "./TaskManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports